import FieldType from '../model/FieldType';
import m from './module';
import {
  convertStringToBoolean,
} from '../util';

const path = '/recap_field_type';
const type = 'FieldType';

class FieldTypeService {
  constructor($log, $q, APIService, DataSyncService) {
    "ngInject";
    this.$log = $log;
    this.$q = $q;
    this.APIService = APIService;
    this.DataSyncService = DataSyncService;
  }

  create(data) {
    const booleanFields = ['has_options', 'in_recap', 'active'];
    for (let field of booleanFields) {
      if (data[field] !== undefined && (typeof data[field] === 'string' || data[field] instanceof String)) {
        data[field] = convertStringToBoolean(data[field]);
      }
    }
    return new FieldType(data);
  }

  getById(id, config = null) {
    return this.DataSyncService.getObjectByIdFromMultiple(type, path, id, data => this.create(data), config);
  }

  getAll(config = null) {
    return this.DataSyncService.getMultipleObjects(type, path, data => this.create(data), config);
  }
}

m.service('FieldTypeService', FieldTypeService);
